import { AxiosError } from 'axios';
import { GET_GSC_DOWNLOAD_ERROR_FILE_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_GSC_DOWNLOAD_ERROR_FILE_QUERY_KEY } from '../../constants/queryKeys';
import {DownloadFileResponse, GenericErrorResponse} from '../typings';

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  enabled?: boolean;
  onSuccess?: (data: DownloadFileResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetDownloadErrorFile = ({ uuid, enabled = false, onSuccess, onError }: Input) => {
  const getDownloadErrorFile = async () => {
    const res = await axiosClient.get<DownloadFileResponse>(GET_GSC_DOWNLOAD_ERROR_FILE_URL(uuid));
    return res.data;
  };
  return useCustomQuery([GET_GSC_DOWNLOAD_ERROR_FILE_QUERY_KEY], getDownloadErrorFile, {
    onSuccess,
    onError,
    enabled,
  });
};
